import * as React from "react";
import { v4 as uuid } from "uuid";

// tslint:disable-next-line:no-implicit-dependencies
import Worker from "worker-loader!./worker.ts";
import {
  DestroyEventData,
  EventData,
  InitEventData,
  isRetSvgEvent,
  ReqSvgEventData,
} from "./events";

interface AbcSvgProps {
  abc: string;
}

interface AbcSvgState {
  loading: boolean;
  svg: string;
  errorHtml: string;
}

export class AbcSvg extends React.Component<AbcSvgProps> {
  state: AbcSvgState = {
    loading: true,
    svg: "",
    errorHtml: "",
  };

  highlightNote = (noteId: number | null) => {
    if (this._el) {
      Array.from(this._el.querySelectorAll(`[data-playing=true]`)).forEach(
        el => ((el as HTMLElement).dataset.playing = ""),
      );
      if (noteId !== null) {
        const el = this._el.querySelector(`.abc_note_${noteId}`);
        if (el) {
          (el as HTMLElement).dataset.playing = "true";
        }
      }
    }
  };

  componentWillMount() {
    this._worker.addEventListener("message", this._handleWorkerMessage);
    const eventData: InitEventData = { type: "init", id: this._id };
    this._worker.postMessage(eventData);
  }

  componentWillUnmount() {
    const eventData: DestroyEventData = { type: "destroy", id: this._id };
    this._worker.postMessage(eventData);
    this._worker.removeEventListener("message", this._handleWorkerMessage);
  }

  shouldComponentUpdate(nextProps: AbcSvgProps, nextState: AbcSvgState) {
    // basically, don't re-render on prop updates
    if (
      nextState.svg !== this.state.svg ||
      nextState.errorHtml !== this.state.svg ||
      nextState.loading !== this.state.loading
    ) {
      return true;
    }
    return false;
  }

  componentWillReceiveProps(nextProps: AbcSvgProps) {
    if (nextProps.abc !== this.props.abc) {
      this.setState({ loading: true });
      // wait before refreshing to prevent excessive recalculations
      clearTimeout(this._renderTimeout);
      this._renderTimeout = setTimeout(() => {
        const eventData: ReqSvgEventData = {
          type: "reqsvg",
          id: this._id,
          abc: nextProps.abc,
        };
        this._worker.postMessage(eventData);
      }, 400);
    }
  }

  render() {
    const { errorHtml, svg, loading } = this.state;

    return (
      <>
        {loading && <div>Loading...</div>}
        {errorHtml && (
          <div
            style={{ border: "1px solid red", overflowX: "auto" }}
            dangerouslySetInnerHTML={{ __html: errorHtml }}
          />
        )}
        {svg && (
          <div
            ref={this._ref}
            style={{ border: "1px solid blue", overflowX: "auto" }}
            dangerouslySetInnerHTML={{ __html: svg }}
          />
        )}
      </>
    );
  }

  private _el: HTMLDivElement | null;

  private _worker = new Worker();

  private _renderTimeout: number = -1;

  private _id = uuid();

  private _ref = (el: HTMLDivElement | null) => {
    this._el = el;
  };

  private _handleWorkerMessage = (ev: MessageEvent) => {
    const data = ev.data as EventData;
    if (isRetSvgEvent(data)) {
      this.setState({
        svg: data.svg,
        errorHtml: data.error_html,
        loading: false,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/abcSvg/index.tsx